import axios from "axios";

const baseUrl = "https://agilo-backend-nqayctezhq-ts.a.run.app"
// const baseUrl = "http://localhost:5001/agilo-47e6e/us-central1/api";

export default axios.create({
    baseURL: baseUrl,
});
